const DateSeparator = ({ label }) => (
  <div className="flex items-center gap-3 my-3">
    <div className="flex-1 h-px bg-gray-300 opacity-50" />
    <span className="text-xs text-gray-500 bg-gray-200 px-3 py-0.5 rounded-full font-medium flex-shrink-0">
      {label}
    </span>
    <div className="flex-1 h-px bg-gray-300 opacity-50" />
  </div>
);

export default DateSeparator;
